// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__35yvp","name":"Header_name__1OnC7","birthday":"Header_birthday__3GNVL","skeleton":"Header_skeleton__3LfZs"};